<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
<app-notification></app-notification>
<notifier-container></notifier-container>
